export default "__VITE_ASSET__25ba3ba9__"